var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVille(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 109.333,
    height: 109.333,
    viewBox: "0 0 109.333 109.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "villa_FILL0_wght400_GRAD0_opsz48",
    d: "M6,115.333V36.067L84.2,6V60.667H97.111a9.111,9.111,0,1,1,18.222,0v54.667Zm9.111-9.111H43.963V60.667h31.13V19.211L15.111,42.293Zm37.963,0H75.093v-16.7H84.2v16.7h22.019V69.778H53.074ZM34.852,51.556ZM79.648,106.222ZM79.648,102.426Z",
    transform: "translate(-6 -6)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVille);
export default __webpack_public_path__ + "static/media/ville.adc4c019e1ad7253dbee61b72dd679e2.svg";
export { ForwardRef as ReactComponent };